export default __webpack_public_path__ + "static/media/330_dummy2016-kosmetik-mobile-de.948a3093.png";